module.exports = __webpack_public_path__ + "img/germany-leukaemia-male.aa38e7d1.png";